"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ExposedGlobalReceiver = /** @class */ (function () {
    function ExposedGlobalReceiver(logger) {
        this.logger = logger;
    }
    ExposedGlobalReceiver.prototype.setEventCallback = function (callback) {
        this.eventCallback = callback;
    };
    ExposedGlobalReceiver.prototype.accept = function (event) {
        if (this.eventCallback) {
            this.eventCallback(event);
        }
    };
    return ExposedGlobalReceiver;
}());
exports.default = ExposedGlobalReceiver;
